import React, { useMemo } from 'react';
import { IProps } from '.';
import Icon, { Icons } from '@components/Icon';
import { theme } from 'src/styles/theme';
import { useTranslations } from '@hooks/useTranslations';
import Spinner from '@components/Spinner';
export const PrePreOrderCheckoutTransitionOverlayTemplate: React.FC<IProps> = ({
    className,
    transitionOverlayError,
    isAssistedFinance,
    handleRedirect,
}) => {
    const { t } = useTranslations();

    return useMemo(() => {
        return (
            <div className={className}>
                <div className="container">
                    {transitionOverlayError ? (
                        <div className="failed">
                            <Icon name={Icons.Cancel} />
                        </div>
                    ) : (
                        <div className="spinnerWrapper">
                            <Icon className="folderIcon" name={Icons.Folder} />
                            <Spinner size={25} border={3} color={theme.colors.black} />
                        </div>
                    )}
                    <span className="title">
                        {transitionOverlayError
                            ? t(
                                  isAssistedFinance
                                      ? 'transitionOverlayTitleFailedAssistedSales'
                                      : 'transitionOverlayTitleFailed'
                              )
                            : t(
                                  isAssistedFinance
                                      ? 'transitionOverlayTitleSuccessAssistedSales'
                                      : 'transitionOverlayTitleSuccess'
                              )}
                    </span>
                    {transitionOverlayError ? (
                        <div className="actionSection">
                            <div className="wrapper">
                                <span>
                                    {t(
                                        isAssistedFinance
                                            ? 'transitionOverlayRetryTitleAssistedSales'
                                            : 'transitionOverlayRetryTitle'
                                    )}
                                </span>
                                <button onClick={handleRedirect}>
                                    {t(
                                        isAssistedFinance
                                            ? 'transitionOverlayRetryAssistedSales'
                                            : 'transitionOverlayRetry'
                                    )}
                                </button>
                            </div>

                            <div className="wrapper">
                                <span>
                                    {t(
                                        isAssistedFinance
                                            ? 'transitionOverlayCallTitleAssistedSales'
                                            : 'transitionOverlayCallTitle'
                                    )}
                                </span>
                                <a
                                    className="call"
                                    href={`tel:${t(
                                        isAssistedFinance
                                            ? 'transitionOverlayCallPhoneAssistedSales'
                                            : 'transitionOverlayCallPhone'
                                    )}`}
                                >
                                    <Icon className="success" name={Icons.Phone} />
                                    {t(
                                        isAssistedFinance
                                            ? 'transitionOverlayCallPhoneAssistedSales'
                                            : 'transitionOverlayCallPhone'
                                    )}
                                </a>
                            </div>
                        </div>
                    ) : (
                        <span className="subtitle">
                            {t(
                                isAssistedFinance
                                    ? 'transitionOverlaySubtitleAssistedSales'
                                    : 'transitionOverlaySubtitle'
                            )}
                        </span>
                    )}
                </div>
            </div>
        );
    }, [transitionOverlayError, isAssistedFinance]);
};
